/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/mobility_1': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M10.944 20.494l-1.051 1.07a.501.501 0 00.713.702l1.051-1.072a.5.5 0 10-.713-.7zM12.123 13.217l6.659 6.66s4.774-7.699 2.907-9.566c-1.869-1.869-9.566 2.906-9.566 2.906zM18 15.768a1.767 1.767 0 11-.001-3.535A1.767 1.767 0 0118 15.768zM14.35 17.02l-2.04 2.08a.493.493 0 00-.149.36c0 .13.06.261.149.351a.522.522 0 00.71 0l2.04-2.09a.47.47 0 00.15-.351.497.497 0 00-.15-.351.514.514 0 00-.71.001z"/><path pid="1" d="M28 19.354L31.354 16 28 12.646V4h-8.646L16 .646 12.647 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646zM30.646 16L28 18.646v-5.293L30.646 16zM16 1.354L18.646 4h-5.292L16 1.354zM1.354 16L4 13.354v5.292L1.354 16zM16 30.646L13.354 28h5.292L16 30.646zM26 26H6V6h20v20z"/>'
  }
})
